import { useEffect } from "react";
import { useHierarchy, useTask } from "@/data/hooks";
import { useConcept } from "@/features/concept-provider";
import { openTask } from "@/features/ui-state";
import { describeError } from "@/data/api";
import { navigate } from "@/router";

/** #/task/HUM-12 — resolves the task, shows its home list, and opens its detail there. */
export function TaskRoute({ readableId }: { readableId: string }) {
  const { concept } = useConcept();
  const h = useHierarchy();
  const { task, error, isLoading } = useTask(readableId);
  useEffect(() => {
    if (!task || !h.loaded) return;
    const route = task.projectId
      ? ({ name: "project", id: task.projectId } as const)
      : task.spaceId
        ? ({ name: "space", id: task.spaceId } as const)
        : task.areaId
          ? ({ name: "area", id: task.areaId } as const)
          : ({ name: "inbox" } as const);
    // Closed/snoozed tasks may be hidden in the home list; open as a sheet so it's always visible.
    const hiddenInList = task.status === "done" || task.status === "cancelled" || task.flags.isSnoozed || !!task.deletedAt;
    navigate(route, task.areaId && !task.spaceId ? { tab: "all" } : undefined, { replace: true });
    openTask(task.id, hiddenInList ? "overlay" : "list");
  }, [task, h.loaded]);
  if (error) return <concept.EmptyState message={describeError(error)} />;
  if (isLoading) return null;
  return null;
}
